<template>
  <div class="modal"
       v-if="aliveState">
    <div v-drag
         class="wrap-container"
         :style="customStyle"
         :id="id"
         v-if="aliveState">
      <div class="wrap-header">
        <div class="wrap-title">{{title}}</div>
        <div class="wrap-close-icon"
             @click="destroySelf">×</div>
      </div>
      <div class="wrap-content">
        <slot></slot>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Wrap',
  created() {
    this.$eventBus.$on('closeWindow', this.closeWindow);
    this.$eventBus.$on('openWindow', this.openWindow);
    this.$eventBus.$on('closeAll', this.closeAll);
  },
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted() {},
  data() {
    return {
      aliveState: false
    };
  },
  methods: {
    destroySelf() {
      this.aliveState = false;
    },
    closeWindow(val) {
      if (this.id === val) {
        this.aliveState = false;
      }
    },
    openWindow(val) {
      if (this.id === val) {
        this.aliveState = true;
      }
    },
    closeAll() {
      this.aliveState = false;
    }
  },
  directives: {
    drag: {
      inserted: function(el) {
        el.onmousedown = function(ev) {
          if (ev.target.className == 'wrap-header' || ev.target.className == 'wrap-title') {
            var disX = ev.clientX - el.offsetLeft;
            var disY = ev.clientY - el.offsetTop;
            document.onmousemove = function(ev) {
              var l = ev.clientX - disX;
              var t = ev.clientY - disY;
              el.style.left = l + 'px';
              el.style.top = t + 'px';
            };
          }
          document.onmouseup = function() {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('closeWindow', this.closeWindow);
    this.$eventBus.$off('openWindow', this.openWindow);
    this.$eventBus.$off('closeAll', this.closeAll);
  }
  //   name: "Card",
  //   props: {
  //     height: {
  //       type: String,
  //       default: "420px"
  //     },
  //     width: {
  //       type: String,
  //       default: "709px"
  //     }
  //   }
};
</script>

<style scoped>
.modal {
  background-color: rgba(33, 33, 33, 0.5);
  position: fixed;
  top: 0;
  bottom: -4px;
  left: 0;
  right: 0;
  z-index: 30;
}
.wrap-container {
  background: #fafafa;
  border: 1px solid #777b87;
  /* box-shadow: 1px 1px 1px 1px #777b87; */
  border-radius: 2px 2px 0px 0px;
  border-radius: 1px;
  margin: 0 0 6px 0;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -300px);
  z-index: 10;
}
.wrap-header {
  height: 31px;
  background-color: #434343;
  display: flex;
  justify-content: space-between;
  color: #fff;
  line-height: 31px;
  cursor: default;
}
.wrap-title {
  margin-left: 10px;
}
.wrap-close-icon {
  margin-right: 10px;
  cursor: pointer;
}
.wrap-content {
  /* margin: 10px; */
}
</style>



// WEBPACK FOOTER //
// src/lib/alertbox/src/AlertBox.vue